export default __webpack_public_path__ + "static/media/pendant.8d0e60c6.png";